// extracted by mini-css-extract-plugin
export default {"carimage":"CarLogoImage-module__carimage--DtQjJ","carimagecontainer":"CarLogoImage-module__carimagecontainer--CXtVy"};